module.exports = __webpack_public_path__ + "img/booker_merci_hubert.11173056.png";